export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/t_shirts.245a7d0.svg";